export class ListGitRepositoriesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "gitRepositories",
            "baseName": "gitRepositories",
            "type": "Array<GitRepository>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGitRepositoriesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
